import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth";
import { useLang } from "@/i18n";
import { Shell } from "@/components/Shell";
import { LangToggle } from "@/components/LangToggle";
import { SignOut, ChartBar, Receipt, IdentificationCard } from "@phosphor-icons/react";

export default function Profile() {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <Shell title={t("profile")}>
      <div className="space-y-4">
        <div className="rounded-2xl bg-slate-800 text-white p-5 flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-emerald-500 grid place-items-center text-2xl font-head font-bold">
            {user?.name?.[0]}
          </div>
          <div>
            <p className="font-head font-bold text-lg">{user?.name}</p>
            <p className="text-slate-300 text-sm">{user?.employee_id} · {user?.role?.toUpperCase()}</p>
            <p className="text-slate-400 text-xs">{user?.headquarters}</p>
          </div>
        </div>

        <div className="rounded-xl bg-white border border-slate-200 divide-y">
          <Row icon={IdentificationCard} label={t("mobile")} value={user?.mobile} />
          <Row icon={IdentificationCard} label="Email" value={user?.email} />
          <Row icon={ChartBar} label={t("call_target")} value={user?.call_target} />
        </div>

        <button onClick={() => nav("/dashboard")} data-testid="profile-dashboard" className="w-full min-h-[52px] rounded-xl bg-white border border-slate-200 flex items-center gap-3 px-4 font-semibold text-slate-700"><ChartBar size={20} /> {t("dashboard")}</button>
        <button onClick={() => nav("/expenses")} data-testid="profile-expenses" className="w-full min-h-[52px] rounded-xl bg-white border border-slate-200 flex items-center gap-3 px-4 font-semibold text-slate-700"><Receipt size={20} /> {t("expenses")}</button>

        <div className="flex items-center justify-between rounded-xl bg-white border border-slate-200 px-4 py-3">
          <span className="font-semibold text-slate-700">Language</span>
          <LangToggle />
        </div>

        <button onClick={logout} data-testid="logout-btn" className="w-full min-h-[52px] rounded-xl bg-red-500 text-white font-semibold flex items-center justify-center gap-2"><SignOut size={20} /> {t("logout")}</button>
      </div>
    </Shell>
  );
}

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center gap-3 px-4 py-3">
      <Icon size={20} className="text-slate-400" />
      <span className="text-sm text-slate-500 flex-1">{label}</span>
      <span className="text-sm font-semibold text-slate-800">{value || "—"}</span>
    </div>
  );
}
